'use client';
import Cookies from 'js-cookie';

export function getGuestIdFromCookieClient() {
  return Cookies.get('guestId');
}
